import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              modelId: 'ent:!subrecips:!subrecip',
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'subrecipientId',
                              },
                              '!code': {
                                '@$': 'subrecipientCode',
                              },
                              '!name': {
                                '@$': 'subrecipientName',
                              },
                              '!descr': {
                                '@$': 'subrecipientDescr',
                              },
                              '!primary_contact': {
                                '{}': {},
                              },
                              '!website': {
                                '@$': 'subrecipientWebsite',
                              },
                              '!institution': {
                                '@$': 'subrecipientInstitution',
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
